

export const treeProps = {
    children: 'children',
    label: 'text'
};